export default __webpack_public_path__ + "static/mg_vip_logo-df39c7cad0f5b7b9f5f1dc130547fddb.png";